import * as React from 'react';
import { useRecoilState } from 'recoil';
import { ICmdTableActionFilter, ICmdTableFilterTable } from '../types';
import useFilter from '../hooks/useFilter';
import TextFilter from '../Filter/TextFilter';
import SortButton from './SortButton';
import { tableFilterAtomFamily } from '../CmdTableState';

interface ThSearchProps {
  tableName: string;
  id: string;
  title: string;
  isSortable?: boolean;
  tooltip?: string;
}

function ThSearch(props: ThSearchProps): JSX.Element {
  const [tableActionsFilters, setTableActionsFilters] = useRecoilState(
    tableFilterAtomFamily({ [props.tableName]: props.id })
  );
  const { getFilterData } = useFilter(props.tableName);

  const handleOnClick = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.preventDefault();
    const { id } = event.currentTarget;

    setTableActionsFilters((oldState: ICmdTableActionFilter | null) => {
      if (oldState) {
        const newState = {
          ...oldState,
          id: props.id,
          isOpen: true,
          isActionChipsOpen: false,
        };
        return newState;
      }
      return oldState;
    });

    if (id) {
      if (!tableActionsFilters) {
        const dataForFilter: ICmdTableFilterTable = {
          type: 'inputSearch',
          value: '',
          values: '',
          required: false,
        };
        getFilterData(props.tableName, props.id, dataForFilter, false);
      }
    }
  };

  const renderSearch = (): JSX.Element | null => {
    if (
      tableActionsFilters &&
      tableActionsFilters.isOpen &&
      !tableActionsFilters.isActionChipsOpen &&
      tableActionsFilters.data
    ) {
      return (
        <div className="open">
          <TextFilter
            id={props.id}
            tableName={props.tableName}
            filterValues={tableActionsFilters.data}
            title={props.title}
          />
        </div>
      );
    }

    return null;
  };

  return (
    <div
      className={`cmd-table-actions ${
        tableActionsFilters && tableActionsFilters.values ? 'active' : ''
      }`}
      style={{
        // minWidth: props.minWidth || '150px',
        // maxWidth: props.maxWidth || '300px',
        flex: 1,
        whiteSpace: 'nowrap',
        cursor: 'pointer',
      }}
      title={props.tooltip}
    >
      <div className="d-flex w-100">
        <div
          id={props.id}
          onClick={handleOnClick}
          className="text-truncate"
          data-cy={`filter-button-text-${props.id}`}
        >
          {props.title}
        </div>

        <a
          id={props.id}
          href="#"
          className="filter cmd-icons cmd-icon-filter"
          onClick={handleOnClick}
          data-cy={`filter-button-${props.id}`}
        >
          {/* test */}
        </a>
        {props.isSortable && <SortButton id={props.id} tableName={props.tableName} />}
        <div />
        {renderSearch()}
      </div>
    </div>
  );
}

export default React.memo(ThSearch);
